import './index.css';

export default function PageHeader({className, eyebrow, title, subtitle, children }) {
    return (
        <header className={`page-header ${className || ''}`}>
            <div className="page-header-inner">
                {eyebrow && <div className="eyebrow">{eyebrow}</div>}
                <h1>{title}</h1>
                {subtitle && <p>{subtitle}</p>}
                {children && <div className="page-header-extra">{children}</div>}
            </div>
        </header>
    );
}
